import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FaBell } from "react-icons/fa";
import { api, timeAgo } from "../api";
import "./NotificationBell.css";

/** Bell in the navbar: saved-search alerts (and anything else sent via /api/me/notifications). */
export default function NotificationBell() {
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(null);
  const box = useRef(null);

  const count = useCallback(() => api("/me/notifications/count").then((d) => setUnread(d.unread || 0)).catch(() => {}), []);
  useEffect(() => { count(); const t = setInterval(count, 60000); return () => clearInterval(t); }, [count]);
  useEffect(() => {
    const away = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", away); return () => document.removeEventListener("mousedown", away);
  }, []);

  const toggle = async () => {
    const next = !open; setOpen(next);
    if (next) { try { const d = await api("/me/notifications?limit=15"); setItems(d.notifications); setUnread(d.unread); } catch { setItems([]); } }
  };
  const read = async (ids) => { try { await api("/me/notifications/read", { method: "POST", body: ids ? { ids } : {} }); } catch { /* ignore */ } count(); };
  const markAll = async () => { await read(); setItems((l) => (l || []).map((n) => ({ ...n, read: true }))); };

  return (
    <div className="nbell" ref={box}>
      <button type="button" className="nbell-btn" onClick={toggle} aria-label={`Notifications${unread ? `, ${unread} unread` : ""}`} aria-expanded={open}>
        <FaBell size={19} />
        {unread > 0 && <span className="nbell-badge">{unread > 9 ? "9+" : unread}</span>}
      </button>
      {open && (
        <div className="nbell-pop" role="menu">
          <div className="nbell-head"><b>Notifications</b>{unread > 0 && <button type="button" onClick={markAll}>Mark all read</button>}</div>
          {!items ? <div className="nbell-empty">Loading…</div> : items.length === 0 ? (
            <div className="nbell-empty">Nothing yet. Save a search and we'll tell you when something new matches.</div>
          ) : items.map((n) => (
            <Link key={n.id} to={n.link || "/dashboard"} className={`nbell-item${n.read ? "" : " unread"}`} onClick={() => { setOpen(false); if (!n.read) read([n.id]); }}>
              {n.image ? <img src={n.image} alt="" /> : <span className="nbell-ico"><FaBell /></span>}
              <span className="nbell-txt"><b>{n.title}</b>{n.body && <em>{n.body}</em>}<small>{timeAgo(n.createdAt)}</small></span>
            </Link>
          ))}
          <Link to="/dashboard/alerts" className="nbell-foot" onClick={() => setOpen(false)}>Manage saved searches</Link>
        </div>
      )}
    </div>
  );
}
